export default {
	type: 'object',
	properties: {
		brandName: {
			type: 'string',
		},
		brandWebsite: {
			type: 'string',
			pattern: '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,11}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
			errorMessage: {
				required: 'Website is required',
				pattern: 'Please enter a valid URL starting with https://',
			},
		},
		brandTwitter: {
			type: 'string',
		},
	},
	required: ['brandName', 'brandWebsite'],
	additionalProperties: false,
}
